import Drawer from "Common/Components/Drawer";
import React, { useState } from "react";
import { X } from "lucide-react";
import CustomInput from "Common/Components/InputFields/CustomInput";
import Select from "react-select";
import { TailSpin } from "react-loader-spinner";

const ThumbnailEdit = ({
  show,
  toggle,
  loader,
  data,
  saveDetails,
  handleAcceptedFiles,
  handleMediaChange,
  isLoading,
  selectedFile,
  setSelectedFile,
 }) => {
  return (
    <Drawer
        show={show}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-[1050] dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {'Edit Details'}
          </Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={(e) => {
              e.preventDefault();
              saveDetails();
              return false;
            }}
          >
             <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Thumbnail Media
                  </label>
                </div>
                <div className="xl:col-span-12">
                  <h6 className="mb-4 text-15">Upload Media</h6>

                  {isLoading ? (
                    <div
                      className="flex justify-center"
                      style={{ marginTop: "10px" }}
                    >
                      <TailSpin
                        visible={true}
                        height="50"
                        width="50"
                        color="#4fa94d"
                      />
                    </div>
                  ) : selectedFile ? (
                    <div className="flex items-center">
                      <div className="relative w-40 h-40">
                        {selectedFile.type.split("/")[0] === "image" ? (
                          <img
                            src={selectedFile.preview}
                            alt="img"
                            className="rounded border-[gray] border"
                            style={{
                              objectFit: "contain",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        ): null}
                        <span
                          style={{
                            position: "absolute",
                            top: "0px",
                            right: "6px",
                            fontSize: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedFile(null);
                          }}
                        >
                          ×
                        </span>
                      </div>
                      <div className="h-3 ml-3">
                        <input
                          type="file"
                          hidden
                          id="uploadimage79"
                          accept="image/*"
                          className="hidden profile-img-file-input"
                          onChange={(e: any) =>
                            handleAcceptedFiles(e.target.files[0])
                          }
                        />
                        <label
                          htmlFor="uploadimage79"
                          className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </label>
                      </div>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        hidden
                        id="uploadimage89"
                        accept="image/*"
                        className="hidden profile-img-file-input"
                        onChange={(e: any) =>
                          handleAcceptedFiles(e.target.files[0])
                        }
                      />
                      <label
                        htmlFor="uploadimage89"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        {"Add Image"}
                      </label>
                    </>
                  )}
                </div>
              </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                id="close-modal"
                data-modal-close="addEmployeeModal"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loader}
                style={{
                  minWidth: "130px",
                  display: "flex",
                  justifyContent: "center",
                }}
                id="addNew"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? "Loading..." : "Save"}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>
  )
};

export default ThumbnailEdit;
